import { jsx } from "react/jsx-runtime";
import { event } from "@zillow/universal-analytics";
import { usePageProps, MediaStepper, getCmsInfoForPage } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const BlockMediaStepper = ({
  innerBlocks,
  attrs: {
    animationTime,
    collapseOthers,
    id: blockId,
    reverse
  }
}) => {
  const pageProps = usePageProps();
  return /* @__PURE__ */ jsx(MediaStepper, { id: blockId, animationTime, collapseOthers, onStepClick: (div) => {
    event({
      // https://dataportal.zillowgroup.net/event-registry/2048
      envelope: {
        event_type_id: "2048",
        event_type_version_id: "1",
        event_template_id: "126",
        event_template_version_id: "1"
        // Master ID: 2284.2.126.1
      },
      clickstream_trigger: {
        trigger_type_nm: "interaction",
        trigger_location_nm: "cms",
        trigger_source_nm: "cms_media_stepper",
        trigger_object_nm: "no_trigger_object"
      },
      semantic: {
        semantic_event_nm: "cms_click"
      },
      cms_info: {
        block_id: blockId || "",
        block_type_cd: "media_stepper",
        block_displayed_txt: div.textContent,
        ...getCmsInfoForPage(pageProps)
      }
    });
  }, reverse, children: innerBlocks.map((block) => {
    var _a;
    const bodyBlock = block.innerBlocks.find((block2) => block2.blockName === "constellation/media-stepper-item-body");
    const imageBlock = (_a = block.innerBlocks.find((block2) => block2.blockName === "constellation/media-stepper-item-media")) == null ? void 0 : _a.innerBlocks.find((block2) => block2.blockName === "constellation/image");
    const imageProp = imageBlock ? {
      src: imageBlock.attrs.src,
      alt: imageBlock.attrs.alt,
      width: imageBlock.attrs.width,
      height: imageBlock.attrs.height
    } : void 0;
    return /* @__PURE__ */ jsx(MediaStepper.Item, { heading: block.attrs.heading, image: imageProp, id: block.attrs.id, children: !!bodyBlock && generateBlockList({
      blocks: bodyBlock.innerBlocks
    }) }, block.attrs.id);
  }) });
};
BlockMediaStepper.propTypes = {
  attrs: PropTypes.shape({
    id: PropTypes.string,
    heading: PropTypes.bool.isRequired,
    animationTime: PropTypes.number.isRequired
  }).isRequired,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export {
  BlockMediaStepper as default
};
